import "../../styles/landing/Page5.css";

const Page5 = () => {
  return (
    <div className="main3">
      <div className="just-cont">
        <h3>FOR OUR PROFESSIONALS</h3>
        <h1>Smartly Deliver Photos to your Clients</h1>
        <div className="highlight-line4"></div>
        <p>
          Clicking photos is one half of the task. The second half is delivering
          them to your clients. Choose the modern way of delivering photos
          smartly using AI.
        </p>
        <p>
          With our paid plans, unlockFotographiya’s best features to grow your
          brand and customer reach, choose from a range of gallery templates to
          best represent your style, get different download settings and much
          more!
        </p>
        <a href="#!" className="know-more-link">
          Know More
        </a>
      </div>
      <div className="imag">
        <img src="/image/page5.jpg" alt="Photographer" />
      </div>
    </div>
  );
};

export default Page5;
